<template>
  <div>
    <h4 class="mb-4">Beliebte Videos</h4>
    <fin-video-scroller :class="$vuetify.breakpoint.smAndUp ? 'px-10' : ''"
                        :video-list="academyVideos"/>

    <h4 class="mt-6 mb-4">Neueste Videos</h4>
    <fin-video-scroller :class="$vuetify.breakpoint.smAndUp ? 'px-10' : ''"
                        :video-list="[...academyVideos].reverse()"/>
  </div>
</template>

<script>
import {academyVideos} from "@/mocks/Academy"
import FinVideoScroller from "@/components/common/video/VideoScroller/index"

export default {
  name: 'fin-academy-wrapper',
  components: {FinVideoScroller},
  data() {
    return {
      academyVideos,
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}
</style>
